import React, { useEffect, useState } from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { FormSelect } from 'components/elements/form-select/FormSelect';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';


function OffcanvasUpdateGuide({ show, onHide, selectedRow, onSubmit, isLoadingButton, selectedGuideCategory, setSelectedGuideCategory }) {
    const { t } = useTranslation();
    const [notification, setNotification] = useState({ variant: '', title: '', message: '' });

    //const [selectedGuideCategory, setSelectedGuideCategory] = useState(null);
    const [GuideCategoryData, setGuideCategoryData] = useState(null); // Add data state
    const [isLoadingGuideCategoryData, setIsLoadingGuideCategoryData] = useState(true); // State for loading spinner

    useEffect(() => {
        getGuideCategoryData();
    }, []); // Fetch data only when the offcanvas is shown or dependencies change

    useEffect(() => {
        if (GuideCategoryData && selectedRow) {
            // Set the selected guide category based on the selected row
            const selectedCategory = GuideCategoryData.find(category => category.id === selectedRow.guide_category_id);
            setSelectedGuideCategory(selectedCategory ? { id: selectedCategory.id, label: selectedCategory.label, value: selectedCategory.value } : null);
        }
    }, [GuideCategoryData, selectedRow]); // Update selected category when data or selected row changes

    // fetch data from api
    const authHeader = useAuthHeader();
    const options = {
        params: {

        },
        headers: {
            Authorization: authHeader,
            Accept: 'application/json'
        }
    };

    // API-Call for all Data
    const getGuideCategoryData = async () => {
        setIsLoadingGuideCategoryData(true);

        // Dynamische URL basierend auf der Umgebung
        const baseURL = process.env.REACT_APP_ENV === 'development'
            ? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
            : `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

        await axios.get(`${baseURL}/public/guides/categories`, options)
            .then(response => {
                const responseData = response.data.data; // Extract the data from the response
                const guideCategories = responseData
                    .map(category => ({
                        id: category.id,
                        value: category.id,
                        label: category.guide_category_title
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                // Set the guide categories data
                setGuideCategoryData(guideCategories);
                setIsLoadingGuideCategoryData(false);
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
                handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
                setIsLoadingGuideCategoryData(false);
            });
    };
        
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Update Guide & Ressource')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Guide & Ressource')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4 d-none">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* ID */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="id">{t('ID')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="id"
                                            defaultValue={selectedRow ? selectedRow.id : ''}
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Title */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="title">{t('Title')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            id="title"
                                            placeholder={t('Enter Guide Title')}
                                            defaultValue={selectedRow ? selectedRow.guide_title : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Title Slug */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="title_slug">{t('Title Slug')}</Form.Label>
                                        <Link
                                            onClick={(e) => {
                                                e.preventDefault();
                                                const titleValue = document.getElementById('title').value;
                                                const formattedSlug = titleValue
                                                    .toLowerCase()
                                                    .replace(/\s+/g, '-')
                                                    .replace(/[!?.]/g, '')
                                                    .replace(/ä/g, 'ae')
                                                    .replace(/ö/g, 'oe')
                                                    .replace(/ü/g, 'ue')
                                                    .replace(/ß/g, 'ss');
                                                document.getElementById('title_slug').value = formattedSlug;
                                            }}
                                            className="ms-2"
                                        >
                                            {t('generate')} <i className="fe fe-refresh-cw"></i>
                                        </Link>
                                        <Form.Control
                                            type="text"
                                            id="title_slug"
                                            placeholder={t('Enter Guide Title Slug')}
                                            defaultValue={selectedRow ? selectedRow.guide_slug : ''}
                                            onFocus={(e) => {
                                                const titleValue = document.getElementById('title').value;
                                                if (e.target.value === '') {
                                                    e.target.value = titleValue
                                                        .toLowerCase()
                                                        .replace(/\s+/g, '-')
                                                        .replace(/ä/g, 'ae')
                                                        .replace(/ö/g, 'oe')
                                                        .replace(/ü/g, 'ue')
                                                        .replace(/ß/g, 'ss');
                                                }
                                            }}
                                            onChange={(e) => {
                                                const slugValue = e.target.value;
                                                const formattedSlug = slugValue
                                                    .replace(/[^a-zA-Z0-9-_]/g, '')
                                                    .replace(/ä/g, 'ae')
                                                    .replace(/ö/g, 'oe')
                                                    .replace(/ü/g, 'ue')
                                                    .replace(/ß/g, 'ss');
                                                e.target.value = formattedSlug;
                                            }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Content */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="content">{t('Content')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            id="content"
                                            placeholder={t('Enter Guide Content')}
                                            defaultValue={selectedRow ? selectedRow.guide_content : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Categories')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* Guide Category */}
                                    {isLoadingGuideCategoryData ? (
                                        <div className="d-flex justify-content-center">
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            {t('Loading categories...')}
                                        </div>
                                    ) : (
                                            <>
                                            <Form.Group className="mb-3" controlId="category">
                                                <Form.Label>
                                                    {t('Choose category')} <span className="text-danger">*</span>
                                                </Form.Label>
                                                {GuideCategoryData.map((category) => (
                                                    <Form.Check
                                                        key={category.id}
                                                        type="checkbox"
                                                        id={`category-${category.id}`}
                                                        label={category.label}
                                                        value={category.id}
                                                        checked={selectedGuideCategory ? selectedGuideCategory.id === category.id : false}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedGuideCategory({
                                                                    id: category.id,
                                                                    label: category.label,
                                                                    value: category.value
                                                                });
                                                            } else {
                                                                setSelectedGuideCategory(null);
                                                            }
                                                        }}
                                                    />
                                                ))}
                                            </Form.Group>
                                            </>
                                        )}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Update Guide & Ressource')}
                                </>
                            ) : (
                                    t('Update Guide & Ressource')
                            )}
                        </Button>
                    </div>

                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasUpdateGuide;